const translations = {
  en: {
    nav: "Projects",
    title_trashlab: "TrashLab App", //[cite: 7, 9]
    description_trashlab:
      "An award-winning waste classification website built during the Dicoding Coding Camp. I acted as the UI/UX Lead and Frontend Developer, translating high-fidelity Figma prototypes into modular, responsive views.", //[cite: 7, 9, 10]

    title_siska: "SISKA Workplace Safety", //[cite: 9, 10]
    description_siska:
      "A workplace safety management system for a mining company. Features comprehensive safety data and reporting APIs integrated with a highly responsive Flutter frontend.", //[cite: 9, 10]

    title_artfolio: "Artfolio App",
    description_artfolio:
      "Artfolio App is an intuitive mobile application designed to empower artists to showcase and share their work with ease, while also fostering a community of appreciation and engagement.",
  
    title_pmr: "PMR Organization Web",
    description_pmr:
      "PMR Organization Website is an all-in-one platform designed to streamline the management of extracurricular school PMR activities, from registration and attendance tracking to organizing activity evidence in a calendar format.",
  
    title_2dn: "2DN Store",
    description_2dn: "2DN Store is an e-commerce platform designed to streamline the online figurine shopping experience for users, while implementing an efficient data management system for admins to manage inventory, sales, and customers.",
  
    title_etraining: "E-Training Website",
    description_etraining: "E-Training Website is an internal training management platform designed to streamline and enhance the training experience for employees, supervisors, and admins.",
  },
  id: {
    nav: "Proyek", 
    title_trashlab: "Aplikasi TrashLab", //[cite: 7, 9]
    description_trashlab:
      "Website klasifikasi sampah pemenang penghargaan yang dibangun selama Dicoding Coding Camp. Saya berperan sebagai UI/UX Lead dan Frontend Developer, menerjemahkan prototipe Figma resolusi tinggi menjadi tampilan modular dan responsif.", //[cite: 7, 9, 10]

    title_siska: "Sistem Keselamatan SISKA", //[cite: 9, 10]
    description_siska:
      "Sistem manajemen keselamatan kerja untuk perusahaan tambang. Menampilkan API pelaporan dan data keselamatan yang komprehensif yang terintegrasi dengan frontend Flutter yang responsif.", //[cite: 9, 10]

    title_artfolio: "Aplikasi Mobile Artfolio", 
    description_artfolio:
      "Artfolio App adalah aplikasi seluler intuitif yang dirancang untuk memberdayakan seniman untuk memamerkan dan berbagi karya mereka dengan mudah, sekaligus menumbuhkan komunitas apresiasi dan keterlibatan.",
  
    title_pmr: "Website Organisasi PMR",
    description_pmr:
      "Website Organisasi PMR adalah platform lengkap yang dirancang untuk memudahkan pengelolaan kegiatan ekstrakurikuler PMR di sekolah, mulai dari pendaftaran dan pelacakan kehadiran hingga pengorganisasian bukti kegiatan dalam format kalender.",
  
    title_2dn: "2DN Store", 
    description_2dn:
      "2DN Store adalah platform e-commerce yang dirancang untuk mempermudah pengalaman belanja figurine online bagi pengguna, serta menerapkan sistem manajemen data yang efisien bagi admin untuk mengelola inventaris, penjualan, dan pelanggan.",
  
    title_etraining: "Website E-Training",
    description_etraining:
      "Website E-Training adalah platform manajemen pelatihan internal yang dirancang untuk mempermudah dan meningkatkan pengalaman pelatihan bagi karyawan, supervisor, dan admin.",
  },
};
  
export default translations;